import React from "react";
import { Drawer as AntdDrawer } from "antd";
import CustomButton from "../commonComponents/button";

const OttoDrawer = ({
  open,
  onClose,
  title,
  width = 720,
  children,
  footer,
  placement = "right",
  destroyOnClose = true,
  ...rest
}) => {
  return (
    <AntdDrawer
      open={open}
      onClose={onClose}
      title={title}
      width={width}
      placement={placement}
      destroyOnClose={destroyOnClose}
      footer={<CustomButton btnText="Close" handleClick={onClose} />}
      className="otto-drawer"
      {...rest}
    >
      {children}
    </AntdDrawer>
  );
};

export default OttoDrawer;
